import(/* webpackMode: "eager" */ "/build/app/page.tsx");
